import { useTranslation } from 'react-i18next';
import { useActiveLocation } from '../../hooks/useActiveLocation';
import { Select } from '../ui/Select';

const ALL = '__all__';

/** Restaurant (Admin only) and location. Stored in localStorage['qo.location']. */
export const ContextSwitcher = ({ stacked = false }: { stacked?: boolean }) => {
    const { t } = useTranslation();
    const { isAdmin, restaurantId, locationId, restaurants, locations, setRestaurant, setLocation } = useActiveLocation();

    if (locations.length === 0 && !isAdmin) return null;
    const options = [
        ...(!isAdmin && locations.length > 1 ? [{ value: ALL, label: t('shell.allLocations') }] : []),
        ...locations.map((l) => ({ value: l.id, label: l.name })),
    ];
    const width = stacked ? 'w-full' : 'w-56';

    return (
        <div className={stacked ? 'flex flex-col gap-3' : 'flex items-center gap-2'}>
            {isAdmin && restaurants.length > 0 && (
                <Select
                    aria-label={t('shell.restaurant')}
                    className={width}
                    value={restaurantId}
                    onChange={setRestaurant}
                    options={restaurants.map((r) => ({ value: r.id, label: r.name }))}
                />
            )}
            {locations.length === 1 && !isAdmin ? (
                <p className="truncate px-3 text-small font-semibold text-strong">{locations[0].name}</p>
            ) : (
                locations.length > 0 && (
                    <Select
                        aria-label={t('shell.location')}
                        className={width}
                        value={locationId ?? ALL}
                        onChange={(v) => setLocation(v === ALL ? null : v)}
                        options={options}
                    />
                )
            )}
        </div>
    );
};
